import React, { ReactNode, useEffect, useRef, useState } from 'react'
import * as d3 from 'd3';
import { ModalProvider } from 'styled-react-modal'
import LargeModal from '../../../ui/LargeModal'
import { ISeasonBuildUpPlay, ISeasonDefence, ISeasonFinalThird, ISeasonPhysical, ISeasonTeams, ItransferMarketValue, IValueGraphChart } from '../../../types/IValueGraphChart';
import styled from 'styled-components';
import LabelNumber from '../../../styled-components/LabelNumber';
import CustomDropdown from '../../../ui/CustomDropdown';
import { IOption } from '../../../types/IOption';
import LabelText from '../../../ui/LabelText';
import { ModuleSpinner } from '../../../ui/LoadingSpinner/ModuleSpinner';
import SecondaryButton from '../../../ui/SecondaryButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useSearch } from '../../../contexts/PlayerSearchContext';
import { useTheme } from '../../../contexts/ThemeContext';
import { IMatches, ITeams } from '../../../types/IPlayerDetail';
import PositiveArrow from "../../../assets/icons/green_up_arrow.svg";
import NegativeArrow from "../../../assets/icons/red_down_arrow.svg";
import noImageClub from "../../../assets/icons/noImageClub.svg"
import YellowCardSvg from '../../../assets/event_icons/Yellow Card.svg'
import RedCardSvg from "../../../assets/event_icons/Red Card.svg";
import Goal from "../../../assets/event_icons/Goal.svg";
import Assists from "../../../assets/event_icons/Assits.svg";
import CloseIcon from "@mui/icons-material/Close";
import PWNotification from '../../PWNotification';
import dnpIcon from "../../../assets/event_icons/dnp.png";
import suspIcon from "../../../assets/event_icons/susp.png";
import injIcon from "../../../assets/event_icons/inj.png";
import subOnIcon from "../../../assets/event_icons/subon.png";
import subOffIcon from "../../../assets/event_icons/suboff.png";
import PinchIcon from "../../../assets/icons/pinchIcon.svg";
import Opportunity from '../../../assets/event_icons/opportunity.png'
import PlusIcon from "../../../assets/icons/plusIcon.svg";
import MinusIcon from "../../../assets/icons/minusIcon.svg";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Switch from '../../../ui/CustomSwitch';
import noDataBackground from "../../../assets/images/NoDataBackground.png"
import { IAttributeDriver } from '../../../types/IValueGraphChart';
import IApiResponse from '../../../types/IApiResponse';
import handleApiResponse from '../../../utils/handleApiResponse';
import apiUrls from '../../../config/apiUrls';
import { postData } from '../../../services/api';

const YAxisContainer = styled.div`
  position: sticky;
  left: 0;
  z-index: 0;
  width: 200px;
  box-shadow: 10px -1px 10px -5px rgba(0, 0, 0, 0.25)
`;

const SvgStyled = styled.svg`
   border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const BottomSideBar = styled.div`
  // border-right :3px solid ${({ theme }) => theme.playerDataBorder}
`;

const BottomLeftContainer = styled.div`
  border-bottom :2px solid ${({ theme }) => theme.playerDataBorder}
`;

// const MatchSvgStyled = styled.svg`
//   border-top :1px solid ${({ theme }) => theme.playerDataBorder}
// `;

const SubAttributes = styled.div`
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme }) => theme.expanderColor};
`;

const Exapanders = styled.div`
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme }) => theme.expanderColor};
    color : ${({ theme }) => theme.playerColor}
`;

const Options: IOption[] = [
    { value: 'Football', label: 'Football' },
    // { value: 'Financial', label: 'Financial' },
    // { value: 'Market', label: 'Market' },
    // { value: 'Commercial', label: 'Commercial' },
    { value: 'Attribute-score', label: 'Attribute score' },
];

interface SelectedAttribute {
    isFinalThird: boolean;
    isBuildUpPlay: boolean;
    isDefence: boolean;
    isPhysical: boolean;
}

interface Attribute {
    color: string;
    text: string;
}

interface SvgElementConfig {
    ref: React.MutableRefObject<SVGSVGElement | null>;
    width: number;
    height: number;
}

interface Point {
    x: number;
    y: number;
    value: number;
    color: string;
}

interface LineEnd {
    data: Point;
}

type Category = 'finalThird' | 'buildUpPlay' | 'defence' | 'physical';

const attributeData: { [key in keyof SelectedAttribute]: Attribute[] } = {
    isFinalThird: [
        { color: '#FF3864', text: 'finishing shots' },
        { color: '#00A1E4', text: 'finishing aerial' },
        { color: '#F2E94E', text: 'attack positioning' }
    ],
    isBuildUpPlay: [
        { color: '#FF3864', text: 'creativity' },
        { color: '#00A1E4', text: 'crossing' },
        { color: '#F2E94E', text: 'dribbling' },
        { color: '#4AF075', text: 'passing accuracy' }
    ],
    isDefence: [
        { color: '#FF3864', text: 'Ball Recovery' },//aggression
        { color: '#00A1E4', text: 'defensive Headers' },
        { color: '#F2E94E', text: 'tackling' }
    ],
    isPhysical: [
        { color: '#FF3864', text: 'speed' },
        { color: '#00A1E4', text: 'strength' },
        { color: '#F2E94E', text: 'work rate' }
    ]
};

const AttributeItem: React.FC<{ color: string; text: string }> = ({ color, text }) => (
    <div className='detail-attributes-container'>
        <span className='attributes-marker' style={{ backgroundColor: color }}></span>
        <LabelNumber className='position-text attribute-text'>{text}</LabelNumber>
    </div>
);

const attributes = [
    { key: 'isFinalThird', label: 'FINAL THIRD', color: '#00D1A8' },
    { key: 'isBuildUpPlay', label: 'BUILD UP PLAY', color: '#FF7800' },
    { key: 'isDefence', label: 'DEFENCE', color: '#C9F0B5' },
    { key: 'isPhysical', label: 'PHYSICAL', color: '#FFC2C2' },
];

const renderSelectedAttributeDetails = (selectedAttribute: SelectedAttribute) => {
    for (const [key, attributes] of Object.entries(attributeData) as [keyof SelectedAttribute, Attribute[]][]) {
        if (selectedAttribute[key]) {
            return (
                <SubAttributes className='detail-attributes'>
                    {attributes.map((attr, index) => (
                        <AttributeItem key={index} color={attr.color} text={attr.text} />
                    ))}
                </SubAttributes>
            );
        }
    }
    return null;
};

const ValueGraphChart: React.FC<IValueGraphChart> = ({ transferValueData, attributesDriverData, playerId, isFullView, isLoading }) => {
    
    let tooltipRef: NodeJS.Timeout;
    const { theme } = useTheme();
    const { isTransferMarket , selectedGraph , setSelectedGraph , selectedOption} = useSearch();
    const TransferMarketYAxis = useRef<SVGSVGElement>(null);
    const TransferValuationSVG = useRef<SVGSVGElement>(null);
    const attributionYAxis = useRef<SVGSVGElement | null>(null);
    const MatchSVG = useRef<SVGSVGElement | null>(null);
    const eventSVG = useRef<SVGSVGElement | null>(null);
    const goalAssistSVG = useRef<SVGSVGElement | null>(null);
    const attributionSVG = useRef<SVGSVGElement | null>(null);
    const chartRef = useRef<HTMLDivElement | null>(null);
    const SeasonSVG = useRef<SVGSVGElement | null>(null);
    const contributionSVG = useRef<SVGSVGElement | null>(null);

    const [isLargeModalOpen, setLargeModalIsOpen] = useState(false);
    // const [selectedGraph, setSelectedGraph] = useState<string>('Football');
    const [selectedAttribute, setSelectedAttribute] = useState({
        isFinalThird: false,
        isBuildUpPlay: false,
        isDefence: false,
        isPhysical: false
    });
    const [hasNoAttributes, sethasNoAttributes] = useState<boolean>(false)
    const [hasfinalthirdNoAttributes, sethasfinalthirdNoAttributes] = useState<boolean>(false)
    const [hasbuildupNoAttributes, sethasbuildupNoAttributes] = useState<boolean>(false)
    const [hasdefenceNoAttributes, sethasdefenceNoAttributes] = useState<boolean>(false)
    const [currentSeason, setCurrentSeason] = useState<string | null>(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [attributeGraphHeight,setAttributeGraphHeight] = useState<number>(414);
    const attributionGraphBaseHeight = 414;
    const colors = [theme.playerCardBackground, theme.playerContentBackground];
    const dataLength = transferValueData?.transferValueBenchmark?.length!
    // const barWidth = dataLength > 10 ? 50 : 260;
    const containerRef = useRef<HTMLDivElement>(null);
    const containerWidth = containerRef.current?.offsetWidth ?? 0;
    const calculatedBarWidth = containerWidth / dataLength;
    const barWidth = calculatedBarWidth < 260 && calculatedBarWidth > 50 ? calculatedBarWidth : calculatedBarWidth > 260 ? 260 : 50 
    // const barWidth = dataLength <= 4 ? 260 : dataLength > 4 && dataLength <= 10 ? 130 : 50
    // dataLength <= 4 ? 260 : dataLength > 4 && <= 10 ? 200 : dataLength > 10 && <=20 ? 130 : 50
    const totalGraphWidth =  barWidth * (transferValueData?.transferValueBenchmark?.length!);
    const padding = 40;
    const bottomPadding = 12;
    const AttributionSvg = useRef<d3.Selection<SVGSVGElement, unknown, null, undefined> | null>(null);
    const AttributesGroup = useRef<d3.Selection<SVGGElement, unknown, null, undefined> | null>(null);
    const updateAttributeYAxis = useRef<(scale: d3.ScaleLinear<number, number>) => void>();
    const margin = { top: 40, right: 0, bottom: 0, left: 0 };
    const [eventsInfoCard , setEventsInfoCard] = useState<boolean>(false)
    const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
    const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null)
    const [currentScale, setCurrentScale] = useState(1); // Track zoom level
    const [seasonAtrributesInfo , setSeasonAttributesInfo] = useState<{
            finalThird: ISeasonFinalThird;
            buildUpPlay:ISeasonBuildUpPlay;
            defence : ISeasonDefence;
            physical : ISeasonPhysical;
            matchDate : string;
            // seasonEndDate: string;
        }| null>(null);
    
        const [selectedInfoAttribute , setSelectedInfoAttribute] = useState({
            isFinalThird: false,
            isBuildUpPlay: false,
            isDefence: false,
            isPhysical: false,
        })
    const [seasonValuationInfo, setSeasonValuationInfo] = useState<{
            transferMarketValue: string;
            matchDate : string
    } | null>(null);

    const [isLeague , setIsLeague] = useState<boolean>(false);
    
    // const [attr]

    let pathClass: string;
    let lineGenerator: any;
    // let currentScale = 1;

    const modalData = {
        "headerTitle": "Player's score below threshold",
        "actionTag": " ",
        "items": [
            {
                "subTitle": " ",
                "description": "When a player hasn't played enough minutes, the small amount of data collected from their performances can be misleading. So unless they perform a certain action enough times in the minutes that they have played, we won't show scores relating to that action.",
            },
        ],
    };
      
    useEffect(()=>{
        if(selectedGraph === 'Attribute-score'){setDisplayCustomNotification(true)}
      },[selectedGraph])
      
        useEffect(() => {
          setCustomNotificationContent(
            <div className="notification">
              <p className="sortlist-notofication-content">
                <img src={PinchIcon} width={24} height={24}/>
                <LabelText className="squad-chart-tooltip notification-content">Scroll up/down to zoom
                </LabelText>
                  <LabelText
                    className="player-given-name notification-content"
                  >
                    - Don’t show again
                  </LabelText>
              </p>
            </div>
          );
        }, [displayCustomNotification]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            if (entries.length > 0) {
                const { width, height } = entries[0].contentRect;
                if (width !== dimensions.width || height !== dimensions.height) {
                    setDimensions({ width, height });
                }
            }
        });

        if (TransferValuationSVG.current && TransferMarketYAxis.current) {
            resizeObserver.observe(TransferValuationSVG.current.parentElement!);
        }

        
        
        return () => resizeObserver.disconnect();
    }, [dimensions.width, dimensions.height]);

    const setSvgAttributes = (svg: d3.Selection<SVGSVGElement, unknown, null, undefined>, width: number, height: number) => {
        svg.attr('width', width).attr('height', height).selectAll("*").remove();
    };

    const createGroup = (svg: d3.Selection<SVGSVGElement, unknown, null, undefined>, margin: { top: number; left: number }) => {
        return svg.append('g')//.attr('transform', `translate(${margin.left},${margin.top})`);
    };

    const drawYAxis = (
        yAxisDivisions: { value: number; text: string }[],
        yMainFGroup: d3.Selection<SVGSVGElement, unknown, null, undefined>,
        yAxisLineGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        totalWidth: number,
        yScale: d3.ScaleLinear<number, number, never>,
        height: number,
        margin: { top: number; right: number; bottom: number; left: number; }
    ) => {

        const yAxisText = yMainFGroup
            .selectAll(".y-axis-text")
            .data(yAxisDivisions, (d: any) => d.value) // Use `value` as a unique key
            .join(
                (enter) =>
                    enter
                        .append("text")
                        .attr("class", "y-axis-text")
                        .attr("x", 160)
                        .attr("y", (d) => yScale(d.value) - 8)
                        .style("text-anchor", "end")
                        .style("font-size", "20px")
                        .style("font-weight", "500")
                        .style("font-family", "DM Mono")
                        .style("fill", theme.playerColor)
                        .text((d) => d.text || ""),
                (update) =>
                    update.style("fill", theme.playerColor) // Update style if necessary
            );

        const yGridLines = yAxisLineGroup
            .selectAll(".y-grid-line")
            .data(yAxisDivisions, (d: any) => d.value) // Use `value` as a unique key
            .join(
                (enter) =>
                    enter
                        .append("line")
                        .attr("class", "y-grid-line")
                        .attr("x1", -180)
                        .attr("y1", (d) => yScale(d.value))
                        .attr("x2", totalWidth)
                        .attr("y2", (d) => yScale(d.value))
                        .style("stroke", theme.playerDataBorder)
                        .style("stroke-width", 1),
                (update) =>
                    update // Update positions dynamically
                        .attr("x1", -180)
                        .attr("x2", totalWidth)
            );

        // yAxisLineGroup
        //     .selectAll(".y-axis-shadow")
        //     .data([0]) // Single datum for the shadow line
        //     .join("line")
        //     .attr("class", "y-axis-shadow")
        //     .attr("x1", 198)
        //     .attr("y1", 0)
        //     .attr("x2", 198)
        //     .attr("y2", height + margin.top - margin.bottom)
        //     .style("stroke", theme.playerDataBorder)
        //     .style("stroke-width", 3);

        const updateYAxis = (newYScale: d3.ScaleLinear<number, number, never>) => {
            yAxisText
                .transition()
                .duration(500)
                .attr("y", (d) => newYScale(d.value) - 15);
            yGridLines
                .transition()
                .duration(500)
                .attr("y1", (d) => newYScale(d.value))
                .attr("y2", (d) => newYScale(d.value));
        };

        return updateYAxis;

    };

    const tooltip = d3.select("body").append("div")
        .style("position", "fixed")
        .style("z-index", 999)
        .style("visibility", "hidden")
        .style("background-color", theme.secondaryButtonBackground)
        .style("color", theme.color)
        .style("border", "1px solid ${theme.secondaryButtonBackground}")
        .style("padding", "8px")
        .style("border-radius", "4px")
        .style("box-shadow", "0px 0px 6px rgba(0, 0, 0, 0.1)")
    //.style("opacity", 0);

    const drawLinePath = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        data: any[],
        xAccessor: (d: any) => number,
        yAccessor: (d: any) => number,
        lineColor: string,
        lineGenerator: any,
        strokeWidth = 4
    ): d3.Selection<SVGPathElement, any[], null, undefined> => {
        const line = d3.line<any>()
            .x(xAccessor)
            .y(yAccessor)
            .curve(d3.curveMonotoneX);

        return group.append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", lineColor)
            .attr("stroke-width", strokeWidth)
            .attr("d", lineGenerator);
    };

    const drawPaths = (
        group: any,
        data: any,
        lineGenerator: (data: any) => string,
        pathClass: string,
        strokeColor: string
    ) => {
        const path = group.append("path")
            .datum(data)
            .attr("class", pathClass)
            .attr("fill", "none")
            .attr("stroke", strokeColor)
            .attr("stroke-width", 4)
            .attr("d", lineGenerator(data));
        return path;
    };

    const drawHorizontalLines = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        data: number[],
        x1Fn: (d: number) => number, // Function to compute x1
        x2Fn: (d: number) => number, // Function to compute x2
        y1Fn: (d: number) => number, // Function to compute y1
        y2Fn: (d: number) => number, // Function to compute y2
        lineClass: string = "horizontal-line", // CSS class for the lines
        strokeColor: string = "#ccc", // Default stroke color
        strokeWidth: number = 1 // Default stroke width
    ): void => {
        group
            .selectAll(`.${lineClass}`) // Select existing lines by class
            .data(data) // Bind data to the lines
            .join(
                (enter) =>
                    enter
                        .append("line")
                        .attr("class", lineClass) // Apply the class
                        .attr("x1", x1Fn) // Use the x1 function
                        .attr("x2", x2Fn) // Use the x2 function
                        .attr("y1", y1Fn) // Use the y1 function
                        .attr("y2", y2Fn) // Use the y2 function
                        .attr("stroke", strokeColor)
                        .attr("stroke-width", strokeWidth),
                (update) =>
                    update
                        .attr("x1", x1Fn) // Update x1
                        .attr("x2", x2Fn) // Update x2
                        .attr("y1", y1Fn) // Update y1
                        .attr("y2", y2Fn) // Update y2
                        .attr("stroke", strokeColor)
                        .attr("stroke-width", strokeWidth),
                (exit) => exit.remove() // Remove any lines that are no longer in data
            );
    };

    const drawBackgroundRectangles = <T extends unknown>(
        group: d3.Selection<SVGGElement, unknown, null, undefined>, // D3 group selection
        data: T[], // Data array for the rectangles
        xFn: (d: T, i: number) => number, // Function to compute x position
        yFn: (d: T, i: number) => number, // Function to compute y position
        widthFn: (d: T, i: number) => number, // Function to compute rectangle width
        heightFn: (d: T, i: number) => number, // Function to compute rectangle height
        fillFn: (d: T, i: number) => string, // Function to compute fill color
        strokeFn: (d: T, i: number) => string = () => "none", // Function to compute stroke color (default: none)
        strokeWidth: number = 0, // Default stroke width
        rectClass: string = "background", // CSS class for the rectangles
        isClickable?: boolean,
        graph?: string
    ): void => {
        const rect = group
            .selectAll(`.${rectClass}`) // Select existing rectangles by class
            .data(data) // Bind data to the rectangles
            .join(
                (enter) =>
                    enter
                        .append("rect")
                        .attr("class", rectClass) // Apply the class
                        .attr("x", xFn) // Use the x function
                        .attr("y", yFn) // Use the y function
                        .attr("width", widthFn) // Use the width function
                        .attr("height", heightFn) // Use the height function
                        .attr("fill", fillFn) // Set the fill color
                        .attr("stroke", strokeFn) // Set the stroke color
                        .attr("stroke-width", strokeWidth), // Set the stroke width
                (update) =>
                    update
                        .attr("x", xFn) // Update x position
                        .attr("y", yFn) // Update y position
                        .attr("width", widthFn) // Update width
                        .attr("height", heightFn) // Update height
                        .attr("fill", fillFn) // Update fill color
                        .attr("stroke", strokeFn) // Update stroke color
                        .attr("stroke-width", strokeWidth), // Update stroke width
                (exit) => exit.remove() // Remove rectangles no longer in data
            );
    
        // Apply click event if isClickable is true
        if (isClickable && graph === "eventGraph") {
            rect
                .style("cursor", "pointer")
                .on("click", () => {
                    setEventsInfoCard(true);
                });
        }
        if (isClickable && isFullView && graph === "transferMarketValue") {
            rect
              .style("cursor", "pointer")
              .on("click", (event, d: any) => {
                setSeasonValuationInfo({ transferMarketValue: d?.transferValueText! ,matchDate :new Date(d.matchDate).toLocaleDateString('en-GB')});
              });
        }
        if(isClickable && group === AttributesGroup.current){
            rect
            .style("cursor", "pointer")
            .on("click", (event, d: any) => {
                setSeasonAttributesInfo(prevState => ({
                    finalThird: d.finalThird,
                    buildUpPlay: d.buildUpPlay ,
                    defence: d.defence,
                    physical: d.physical,
                    matchDate :new Date(d.matchDate).toLocaleDateString('en-GB')
                }))
            });
        }
    };
    

    const createSubstitutionRectangle = (
        group: d3.Selection<SVGGElement, IMatches, null, undefined>,
        d: IMatches,
        substitutionType: 'on' | 'off',
        xPos: number,  // Pass the computed x position
        yPos: number,  // Pass the computed y position
        width: number,  // Pass width
        height: number,  // Pass height
        arrowIcon: string, // Pass the icon string (PositiveArrow or NegativeArrow),
        textXPos: number,
        textYPos: number,
        imgXPos: number,
        imgYPos: number
    ) => {
        const substitutionText = substitutionType === 'on' ? 'Subbed on' : 'Subbed off';

        // Rectangle
        group.append("rect")
            .attr('class', 'substitution-rect')
            .attr("x", xPos)
            .attr("y", yPos)
            .attr("rx", 2)
            .attr("ry", 2)
            .attr("width", width)
            .attr("height", height)
            .style("fill", colors[d.matchId % 2])
            .style("stroke", 'black')
            .style("stroke-width", 1)
            .style('cursor', 'pointer')
            .on("mouseover", (event, d) => {
                tooltipRef = setTimeout(() => {
                    tooltip.style("visibility", "visible");
                    tooltip.html(substitutionText);
                }, );
            })
            .on("mousemove", (event) => {
                tooltip
                    .style('left', `${event.clientX - 10}px`)
                    .style('top', `${event.clientY + 20}px`);
            })
            .on("mouseout", () => {
                //clearTimeout(tooltipRef);
                tooltip.style("visibility", "hidden");
            });

        // Substitution minute text
        group.append("text")
            .attr("x", textXPos)  // Adjust the text's x position
            .attr("y", textYPos)  // Adjust the text's y position
            .style("font-size", "10px")
            .style("font-family", "DM Mono")
            .style("font-style", "normal")
            .style('cursor', 'pointer')
            .style("fill", theme.playerColor)
            .text(d.substitutionMinute)
            .on("mouseover", (event, d) => {
              tooltipRef = setTimeout(() => {
                  tooltip.style("visibility", "visible");
                  tooltip.html(substitutionText);
              }, );
          })
          .on("mousemove", (event) => {
              tooltip
                  .style('left', `${event.clientX - 10}px`)
                  .style('top', `${event.clientY + 20}px`);
          })
          .on("mouseout", () => {
              //clearTimeout(tooltipRef);
              tooltip.style("visibility", "hidden");
          });

        // Substitution arrow
        group.append("image")
            .attr("x", imgXPos)  // Adjust the image's x position
            .attr("y", imgYPos)  // Adjust the image's y position
            .style("width", "12px")
            .style("height", "12px")
            .style('cursor', 'pointer')
            .attr("xlink:href", arrowIcon)
            .on("mouseover", (event, d) => {
              tooltipRef = setTimeout(() => {
                  tooltip.style("visibility", "visible");
                  tooltip.html(substitutionText);
              }, );
          })
          .on("mousemove", (event) => {
              tooltip
                  .style('left', `${event.clientX - 10}px`)
                  .style('top', `${event.clientY + 20}px`);
          })
          .on("mouseout", () => {
              //clearTimeout(tooltipRef);
              tooltip.style("visibility", "hidden");
          });
    };

    const appendEventWithCount = (eventsGroup: d3.Selection<SVGGElement, any, null, undefined>, count: number, imageUrl: string, offsetX: number, offsetY: number) => {
        if (count > 0) {
            const eventGroup = eventsGroup.append("g");
            // Append the image once
            eventGroup.append("image")
                .attr("class", "match-image")
                .attr("x", offsetX)
                .attr("y", offsetY)
                .attr("width", 24)
                .attr("height", 24)
                .attr("xlink:href", imageUrl)
                .style('cursor', 'pointer')
                .on("click", () => {
                    setEventsInfoCard(true);
                });
                ;

            // Append text (badge) if count > 1
            if (count > 1) {
                // Append the circle
                eventGroup.append("circle")
                    .attr("cx", offsetX + 25)
                    .attr("cy", offsetY + 4)
                    .attr("r", 10)
                    .style("fill", "#C9F0B5");

                eventGroup.append("text")
                    .attr("x", offsetX + 29)  // Adjust position based on image width
                    .attr("y", offsetY + 5)   // Adjust position to appear as a badge on the image
                    //.style("fill", "black")
                    .style("font-size", "12px")
                    .style("font-weight", "bold")
                    .style("background-color", "red") // Optional for a badge style
                    .style("alignment-baseline", "middle")  // Center the text vertically
                    .text(count);

            }
        }
    };

    const appendEventsForMatch = (eventsGroup: d3.Selection<SVGGElement, any, null, undefined>, x: d3.ScaleBand<number>, d: IMatches) => {
        let currentYOffset = 5;

        // Append goals if present, otherwise skip
        if (d.totalGoals > 0) {

            appendEventWithCount(eventsGroup, d.totalGoals, Goal, x(d.matchId)! + x.bandwidth() / 2 - 12, currentYOffset);
            currentYOffset += 35;  // Increase the offset only if goals are present
        }

        // Append yellow cards if present, otherwise skip
        if (d.totalYellowCards > 0) {
            appendEventWithCount(eventsGroup, d.totalYellowCards, YellowCardSvg, x(d.matchId)! + x.bandwidth() / 2 - 12, currentYOffset);
            currentYOffset += 35;  // Increase the offset only if yellow cards are present
        }

        // Append red cards if present, otherwise skip
        if (d.totalRedCards > 0) {
            appendEventWithCount(eventsGroup, d.totalRedCards, RedCardSvg, x(d.matchId)! + x.bandwidth() / 2 - 12, currentYOffset);
            currentYOffset += 35;  // Increase the offset only if red cards are present
        }

        // Append assists if present, otherwise skip
        if (d.totalAssists > 0) {
            appendEventWithCount(eventsGroup, d.totalAssists, Assists, x(d.matchId)! + x.bandwidth() / 2 - 12, currentYOffset);
            currentYOffset += 35;  // Increase the offset only if assists are present
        }
    };

    const renderMatchData = (
        matchData: IMatches[][],  // Pass the match data as an argument
        MatchGroup: d3.Selection<SVGGElement, unknown, null, undefined>,  // Pass the group to append elements to
        xScale: d3.ScaleBand<number>,  // Pass x scale
        yScale: d3.ScaleLinear<number, number>,  // Optionally pass y scale if needed for other calculations
        theme: any,  // Pass theme or other required styles
        PositiveArrow: string,  // Arrow icons (or paths to them)
        NegativeArrow: string,  // Arrow icons (or paths to them)
        noImageClub: string  // Fallback image URL for no data
    ) => {
        const matchSelection = MatchGroup
            .selectAll("g.match")
            .data(matchData.flat()) // Flatten match data array if necessary

        matchSelection
            .join(
                (enter) => enter
                    .append("g")
                    .attr("class", "match")
                    .each(function (d: IMatches, i) {
                        // Match info text
                        d3.select(this)
                            .append("text")
                            .attr("x", xScale(d.matchId)! + xScale.bandwidth() / 2 + 2)  // Centering text horizontally
                            .attr("y", 20)  // Positioning text vertically
                            .style("font-size", "10px")
                            .style("font-family", "DM Mono")
                            .style("font-style", "normal")
                            .style("fill", theme.playerColor)
                            .text(d.winLoss);

                        // Match image
                        d3.select(this)
                            .append("image")
                            .attr("class", "match-image")
                            .attr("x", xScale(d.matchId)! + xScale.bandwidth() / 2 - 12)  // Centering images horizontally
                            .attr("y", 30)  // Centering images vertically teamName
                            .attr("width", 24)
                            .attr("height", 24)
                            .attr("xlink:href", d.imageDataUrl ? d.imageDataUrl : noImageClub)
                            .on("mouseover", (event, d : any) => {
                                tooltip.style("visibility", "visible").html(d.teamName);
                            })
                            .on("mousemove", (event) => {
                                tooltip
                                    .style('left', `${event.clientX - 10}px`)
                                    .style('top', `${event.clientY + 20}px`);
                            })
                            .on("mouseout", () => {
                                tooltip.style("visibility", "hidden");
                            });

                        // Handle player substitution
                        if (d.isPlayerSubstitutionOn !== null) {
                            const arrowIcon = d.isPlayerSubstitutionOn ? PositiveArrow : NegativeArrow;
                            // Pass the precomputed values for x and y to createSubstitutionRectangle
                            createSubstitutionRectangle(
                                d3.select(this),
                                d,
                                d.isPlayerSubstitutionOn ? 'on' : 'off',
                                (xScale(d.matchId)! + barWidth/2 - 15), //+ xScale.bandwidth() / ( dataLength < 10 ? 3 : 4)) + (dataLength < 10 ? 28 : -2)
                                65, 32, 16, arrowIcon,  // Rectangle position
                                xScale(d.matchId)! + xScale.bandwidth() / 2 + 3, 77,  // Substitution minute text position
                                xScale(d.matchId)! + xScale.bandwidth() / 2 + 4, 67   // Arrow image position
                            );
                        }

                    }),
                (update) => update,  // Handle updates if necessary
                (exit) => exit.remove()  // Remove elements if they no longer exist in the data
            );
    };
    const addSeasonLabel = (group: d3.Selection<SVGGElement, unknown, null, undefined>, seasonName: string, xPosition: number, theme: any , seasonTeamsData : ISeasonTeams[][] , display : boolean) => {
        const x = seasonName.includes('/') ? xPosition + 110 : xPosition + 65
        // if (display) {
            group.append("text")
                .attr("x", x) // Adjust position as needed
                .attr("y", 30) // Position text above the group
                .style("font-size", "14px")
                .style("font-family", "DM Mono")
                .style("font-style", "normal")
                .style("text-transform", "uppercase")
                .style("fill", theme.playerColor) // Use a theme color
                .text(seasonName);
        // }
        
        
    };

    const addSeasonSeparator = (
        group: d3.Selection<SVGGElement, unknown, null, undefined>,
        xPosition: number,
        y1: number,
        y2: number,
        theme: any
    ) => {
        group.append("line")
            .attr("x1", xPosition)
            .attr("y1", y1) // Adjust the vertical position of the line
            .attr("x2", xPosition)
            .attr("y2", y2) // Adjust the height of the line
            .style("stroke", theme.NumberColor) // Red line
            .style("stroke-width", 1)
        //.style("stroke-dasharray", "4,2"); // Optional: dashed line style
    };

    const renderSeasons = (SeasonGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        MatchGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        TransferValuationGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        EventGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        GoalAssistGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        AttributesGroup: d3.Selection<SVGGElement, unknown, null, undefined>, SeasonData: string[],  seasonTeamsData: ISeasonTeams[][], // array of arrays
        matchData: IMatches[][], rectWidth: number, xScale: d3.ScaleBand<number>, theme: any,
    ) => {
        let cumulativeX = 0;
        let display : boolean
        matchData.forEach((seasonMatches, index) => {

            function formatSeasonLabel(dateStr: string): string {
                const date = new Date(dateStr);
                const year = date.getFullYear() % 100;         // Get '24'
                const nextYear = (date.getFullYear() + 1) % 100; // Get '25'
                const month = date.toLocaleString('en-US', { month: 'short' }); // 'Jan'
                return `${month}`
                // ‘${year.toString().padStart(2, '0')}–’${nextYear.toString().padStart(2, '0')};
            }
           
             (seasonTeamsData[index] || []).forEach((team: ISeasonTeams, teamIndex: number) => {
                if (teamIndex === 0) {
                    display = true
                    SeasonGroup.append("image")
                        .attr("xlink:href", team.teamLogoURL)
                        .attr("x", xScale(team.matchId)! + 5)
                        .attr("y", 14)
                        .attr("width", 24)
                        .attr("height", 24);
                        if(seasonTeamsData[index].length > 1){
                            SeasonGroup.append("text")
                            .attr("x", xScale(team.matchId)! + 60)
                            .attr("y", 45)
                            .style("font-family", "DM Mono")
                            .style("font-size", "14px")
                            .style("font-style", "normal")
                            .style("font-weight", "500")
                            .style("line-height", "normal")
                            .style("text-transform", "uppercase")
                            .style("fill", "#111") 
                            .style("font-feature-settings", "'liga' off, 'clig' off")
                            .text(formatSeasonLabel(team.matchDate));
                        }
                }
            
                // 2nd team - show using xScale
                if (teamIndex === 1 && xScale(team.matchId) !== undefined) {
                    display = false
                    SeasonGroup.append("line")
                    .attr("x1",  xScale(team.matchId)!) 
                    .attr("y1", 0)
                    .attr("x2",  xScale(team.matchId)!)
                    .attr("y2", 60)
                    .attr("stroke", "#7C7D79") 
                    .attr("stroke-width", 1)
                    SeasonGroup.append("image")
                        .attr("xlink:href", team.teamLogoURL)
                        .attr("x", xScale(team.matchId)! + 10)
                        .attr("y", 12)
                        .attr("width", 24)
                        .attr("height", 24);

                        SeasonGroup.append("text")
                            .attr("x", xScale(team.matchId)! + 60)
                            .attr("y", 45)
                            .style("font-family", "DM Mono")
                            .style("font-size", "14px")
                            .style("font-style", "normal")
                            .style("font-weight", "500")
                            .style("line-height", "normal")
                            .style("text-transform", "uppercase")
                            .style("fill", "#111") 
                            .style("font-feature-settings", "'liga' off, 'clig' off")
                            .text(formatSeasonLabel(team.matchDate)); 

            addSeasonLabel(SeasonGroup, SeasonData[index], xScale(team.matchId)!, theme , seasonTeamsData , display);
                        

                }
            });
            // Add season label

            addSeasonLabel(SeasonGroup, SeasonData[index], cumulativeX, theme , seasonTeamsData , display);
            
            const seasonWidth = seasonMatches.length * rectWidth;
            if (index > 0) {
                addSeasonSeparator(SeasonGroup, cumulativeX, 0, 50, theme);
                addSeasonSeparator(MatchGroup, cumulativeX, 0, 100, theme);
                addSeasonSeparator(TransferValuationGroup, cumulativeX, 0, 469, theme);
                addSeasonSeparator(EventGroup, cumulativeX, 0, 155, theme);
                addSeasonSeparator(GoalAssistGroup, cumulativeX, 0, 155, theme);
                if (AttributionSvg.current) { addSeasonSeparator(AttributesGroup, cumulativeX, 0, attributeGraphHeight, theme) };
            }
            seasonMatches.forEach((matchEvent, index) => {
                appendEventsForMatch(EventGroup, xScale, matchEvent);
            })

            // Update cumulativeX based on the number of matches in the season
            cumulativeX += seasonWidth;
        });
    };

    const drawBars = (GoalAssistGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        data: any[], className: string, fillColor: string, offsetX: number,
        rectWidth: number, yScaleXg: d3.ScaleLinear<number, number, never>) => {
        GoalAssistGroup
            .selectAll(`rect.${className}`)
            .data(data)
            .join(
                enter => enter.append('rect')
                    .attr('class', className)
                    .attr('width', 16)
                    .attr('rx', 4)
                    .attr('ry', 2)
                    .style('fill', fillColor)
                    .style('cursor', 'pointer'),
                update => update,
                exit => exit.remove()
            )
            .attr('x', (d, i) => i * rectWidth + offsetX)
            // .attr('x', (d, i) => i * xScale.bandwidth() /2)

            .attr('y', d => yScaleXg(d[className === 'blue' ? 'totalXgShot' : 'totalXgAssist']))
            .attr('height', d => 80 - yScaleXg(d[className === 'blue' ? 'totalXgShot' : 'totalXgAssist']))
            .on("mouseover", (event, d) => {
                tooltip.style("visibility", "visible").html(`Ex G: ${d.totalXgShot}<br>Ex A: ${d.totalXgAssist}`);
            })
            .on("mousemove", (event) => {
                tooltip
                    .style('left', `${event.clientX - 10}px`)
                    .style('top', `${event.clientY + 20}px`);
            })
            .on("mouseout", () => {
                tooltip.style("visibility", "hidden");
            });
    }

    const drawAttributeYAxis = (AttributionYAxisGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        AttributesGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
        yTicks: number[],
        attributesYScale: d3.ScaleLinear<number, number, never>,
        theme: any,
        totalGraphWidth: number,
        x1Value: number, // New parameter for x1
        x2Value: number,
        xTextValue: number,
        yTextValue: number,
    ) => {
        const attributeYGridLines = AttributionYAxisGroup.selectAll(".attribute-y-axis-line")
            .data(yTicks)
            .enter()
            .append("line")
            .attr('x1', x1Value)
            .attr('x2', x2Value)
            .attr('y1', (d: any) => attributesYScale(d))
            .attr('y2', (d: any) => attributesYScale(d))
            .attr('stroke', theme.playerDataBorder);

        const attributeYAxisText = AttributionYAxisGroup.selectAll(".attribute-y-axis-text")
            .data(yTicks)
            .enter()
            .append("text")
            .attr('x', xTextValue)
            .attr('y', (d: any) => attributesYScale(d) - yTextValue)
            .attr('dy', '0.35em')
            .attr('text-anchor', 'middle')
            .style("fill", theme.playerColor)
            .style("font-family", "DM Mono")
            .style('font-weight', 500)
            .style('font-size', 20)
            .text((d: any) => d);

        const attributeGridLines = AttributesGroup.selectAll(".attribute-line")
            .data(yTicks)
            .enter()
            .append("line")
            .attr('x1', 0)
            .attr('x2', totalGraphWidth)
            .attr('y1', (d: any) => attributesYScale(d))
            .attr('y2', (d: any) => attributesYScale(d))
            .attr('stroke', theme.playerDataBorder);

        const updateAttributeYAxis = (newYScale: d3.ScaleLinear<number, number, never>) => {
            attributeYAxisText
                .transition()
                .duration(500)
                .attr("y", (d) => newYScale(d) - 12);
            attributeYGridLines
                .transition()
                .duration(500)
                .attr("y1", (d) => newYScale(d))
                .attr("y2", (d) => newYScale(d));
            attributeGridLines
                .transition()
                .duration(500)
                .attr("y1", (d) => newYScale(d))
                .attr("y2", (d) => newYScale(d));
        };

        return updateAttributeYAxis;
    }
    const calculateDistance = (point1: Point, point2: Point) => {
        return Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
    };
    let elements = {
        rects: [] as any[],
        circles: [] as any[],
        texts: [] as any[]
    };
    // drawMergedRectangles(AttributesGroup.current, finalThirdEndPoints, 25, finalThirdScale);
    const drawMergedRectangles = (svgGrp: any, endPoints: LineEnd[], threshold: number, yScale?: any) => {
      const mergedGroups: LineEnd[][] = [];
      const usedIndices = new Set<number>();
      
      // Group points by proximity
      endPoints.forEach((point1, i) => {
          if (usedIndices.has(i)) return;
          const group = [point1];
  
          endPoints.forEach((point2, j) => {
              if (i !== j && !usedIndices.has(j)) {
                  const distance = calculateDistance(point1.data, point2.data);
                  if (distance <= threshold) {
                      group.push(point2);
                      usedIndices.add(j);
                  }
              }
          });
  
          mergedGroups.push(group);
          usedIndices.add(i);
      });
  
      // Draw rectangles and store references
      const elements: { rects: any[]; circles: any[]; texts: any[] } = { rects: [], circles: [], texts: [] };
      
      mergedGroups.forEach(group => {
          const rectPadding = 5;
          const xMin = Math.min(...group.map(p => p.data.x)) - rectPadding;
          const xMax = Math.max(...group.map(p => p.data.x)) + rectPadding;
          const yMin = Math.min(...group.map(p => p.data.y)) - rectPadding;
          const yMax = Math.max(...group.map(p => p.data.y)) + rectPadding;
  
          // Draw rectangle
          const rect = svgGrp.append("rect")
              .attr("x", xMin - 10)
              .attr("y", yMin - 5)
              .attr("width", xMax - xMin + 35)
              .attr("height", yMax - yMin + 8)
              .attr("stroke", "none")
              .attr("fill", theme.secondaryButtonBackground)
              .attr("class", "merged-rect")
              .attr('rx',2)
              // .attr('ry',2)
              .attr("stroke", "#DADADA")
              .attr("stroke-width", 1);
            
  
          elements.rects.push({ rect, group });
  
          group.forEach(point => {
              const circle = svgGrp.append("circle")
                  .attr("cx", point.data.x - 9)
                  .attr("cy", point.data.y - 1)
                  .attr("r", 3)
                  .attr("fill", point.data.color)
                  .attr("class", "merged-circle");
  
              const text = svgGrp.append("text")
                  .attr("x", point.data.x + 10)
                  .attr("y", point.data.y + 2)
                  .attr("text-anchor", "middle")
                  .style("fill", theme.playerColor)
                  .style("font-family", "DM Mono")
                  .style("font-weight", 500)
                  .style("font-size", 10)
                  .text(point.data.value)
                  .attr("class", "merged-text");
  
              elements.circles.push({ circle, point });
              elements.texts.push({ text, point });

          });
      });
  
      return elements;
  };

  

    const createRectangleAndText = (group: d3.Selection<SVGGElement, unknown, null, undefined>, x: number, y: number, width: number, height: number, text: string, fill: string, textColor: string) => {
        // Create the rectangle
        group.append('rect')
            .attr('x', x - 50 / 2)  // Center the rect horizontally
            .attr('y', y - height / 2) // Center the rect vertically
            .attr('width', 50)
            .attr('height', height)
            .attr('fill', fill)
            .attr('rx',2)
            // .attr('ry',2)
            .attr("stroke", "#DADADA")
            .attr("stroke-width", 1);

        // Add the text
        group.append('text')
            .attr('x', x)
            .attr('y', y)
            .attr('dy', '.35em')
            .attr('text-anchor', 'middle')
            .text(text)
            .attr('fill', textColor);
    }

    const createScale = (min: number, max: number) => {
        if (min === max) {
            min -= 1;
            max += 1;
        }
        return d3.scaleLinear()
            .domain([min, max])
            .range([attributeGraphHeight - bottomPadding, padding])
            .nice();
    };

    const finalThirdData = !isLeague ?  attributesDriverData?.finalThird || [] : attributesDriverData?.finalThirdLeague || []
    const buildupPlayData = !isLeague ?  attributesDriverData?.buildUpPlay || [] : attributesDriverData?.buildUpPlayLeague || []
    const defenceData = !isLeague ?  attributesDriverData?.defence || [] : attributesDriverData?.defenceLeague || []
    const physicalData = !isLeague ?  attributesDriverData?.physical || [] : attributesDriverData?.physicalLeague || []

    // Combine all data arrays
    const allData = [
        ...finalThirdData,
        ...buildupPlayData,
        ...defenceData,
        ...physicalData,
    ];

    const transformedData = finalThirdData.map((item, index) => ({
        id: item.id,
        matchDate : item.matchDate,
        finalThird: finalThirdData[index] || {},
        buildUpPlay: buildupPlayData[index] || {},
        defence: defenceData[index] || {},
        physical: physicalData[index] || {},
      }));

    const allAttributesAreZero = physicalData.every(entry => entry.speed === 0 && entry.strength === 0 && entry.workRate === 0);
    const allDefenceZero = defenceData.every(d => d.aggression === 0 && d.defensiveHeaders === 0 && d.tackling === 0)
    const allBuildUpPlayZero = buildupPlayData.every(d => d.creativity === 0 && d.crossing === 0 && d.dribbling === 0 && d.passingAccuracy === 0)
    const allFinathirdZero = finalThirdData.every(d => d.attackPositioning === 0 && d.finishingAerial === 0 && d.finishingShots === 0)
    const allFinalScoreZero = allData.every(d => d.finalScore === 0)

    const getMinMax = (data: any, properties: any) => {
        const values = data.flatMap((item: any) => properties.map((property: any) => item[property]));
        return {
            min: Math.min(...values),
            max: Math.max(...values)
        };
    };

    // Define the properties for each dataset
    const finalThirdProperties = ['finishingShots', 'finishingAerial', 'attackPositioning'];
    const buildUpPlayProperties = ['creativity', 'crossing', 'dribbling', 'passingAccuracy'];
    const defenceProperties = ['aggression', 'defensiveHeaders', 'tackling'];
    const physicalProperties = ['speed', 'strength', 'workRate'];

    // Get min and max values for each dataset
    const { min: finalThirdminValue, max: FinalThirdmaxValue } = getMinMax(finalThirdData, finalThirdProperties);
    const { min: buildUpPlayminValue, max: buildUpPlaymaxValue } = getMinMax(buildupPlayData, buildUpPlayProperties);
    const { min: defenceminValue, max: defencemaxValue } = getMinMax(defenceData, defenceProperties);
    const { min: physicalminValue, max: physicalmaxValue } = getMinMax(physicalData, physicalProperties);

    // Extract finalScore values
    const finalScores = allData.map(item => item.finalScore);

    // Calculate min and max finalScore
    const minFinalScore = Math.min(...finalScores);
    const maxFinalScore = Math.max(...finalScores);

    const attributesYScale = createScale(minFinalScore, maxFinalScore);
    const finalThirdScale = createScale(finalThirdminValue, FinalThirdmaxValue);
    const buildUpPlayScale = createScale(buildUpPlayminValue, buildUpPlaymaxValue);
    const defenceScale = createScale(defenceminValue, defencemaxValue);
    const physicalScale = createScale(physicalminValue, physicalmaxValue);

    const getAttributeYScale = (selectedAttribute: any) => {
        if (selectedAttribute.isFinalThird) return finalThirdScale;
        if (selectedAttribute.isBuildUpPlay) return buildUpPlayScale;
        if (selectedAttribute.isDefence) return defenceScale;
        if (selectedAttribute.isPhysical) return physicalScale;
        return attributesYScale;
    }


    const getPathData = (path: d3.Selection<d3.BaseType, unknown, null, undefined>, d: any, lineGenerator: any, rescaledAttributeY: d3.ScaleLinear<number, number>) => {
        if (path.classed("finishingShots")) return lineGenerator.finishingShots(d, rescaledAttributeY);
        if (path.classed("finishingAerial")) return lineGenerator.finishingAerial(d, rescaledAttributeY);
        if (path.classed("attackPositioning")) return lineGenerator.attackPositioning(d, rescaledAttributeY);
        if (path.classed("creativity")) return lineGenerator.creativity(d, rescaledAttributeY);
        if (path.classed("crossing")) return lineGenerator.crossing(d, rescaledAttributeY);
        if (path.classed("dribbling")) return lineGenerator.dribbling(d, rescaledAttributeY);
        if (path.classed("passingAccuracy")) return lineGenerator.passingAccuracy(d, rescaledAttributeY);
        if (path.classed("aggression")) return lineGenerator.aggression(d, rescaledAttributeY);
        if (path.classed("defensiveHeaders")) return lineGenerator.defensiveHeaders(d, rescaledAttributeY);
        if (path.classed("tackling")) return lineGenerator.tackling(d, rescaledAttributeY);
        if (path.classed("speed")) return lineGenerator.speed(d, rescaledAttributeY);
        if (path.classed("strength")) return lineGenerator.strength(d, rescaledAttributeY);
        if (path.classed("workRate")) return lineGenerator.workRate(d, rescaledAttributeY);
        return lineGenerator.default(d, rescaledAttributeY);
    }

    const rescalePathData = (pathData: string, rescaledAttributeY: d3.ScaleLinear<number, number>) => {
        return pathData
            .split(' ') // Split path data by spaces
            .map((segment: string) => {
                const values = segment.split(','); // Split each segment (e.g., "x,y") into coordinates
                if (values.length === 2) {
                    // const x = parseFloat(values[0]);
                    const y = parseFloat(values[1]);

                    // Rescale the y-coordinate based on the transformed y-scale
                    values[1] = rescaledAttributeY(y).toString(); // Apply rescaled y
                }
                return values.join(','); // Rejoin the coordinates
            })
            .join(' '); // Join all segments back into one path string
    }

    const transferBenchMarkData = transferValueData?.transferValueBenchmark?.length
        ? transferValueData.transferValueBenchmark :
        Array(35).fill({ matchId: 'No Data' });
    

    const xScale = d3.scaleBand<number>()
        .domain(transferBenchMarkData.map(d => d.matchId))
        .range([0, totalGraphWidth]);

    const attributesLinePath = d3.line<any>()
        .x(d => xScale(d.id)! + xScale.bandwidth() / 2)  // Center line in the band
        .y(d => attributesYScale(d.finalScore))
        .curve(d3.curveMonotoneX);

    const createLineGenerator: any = (yValue: string, scale: d3.ScaleLinear<number, number>) =>
        d3.line<any>()
            .x(d => xScale(d.id)! + xScale.bandwidth() / 2)
            .y(d => scale(d[yValue]))
            .curve(d3.curveMonotoneX);
         

    
    const createLineGeneratorsForCategory = (categoryName: Category, scale: d3.ScaleLinear<number, number>) => {
        const attributeNames = {
            finalThird: ['finishingShots', 'finishingAerial', 'attackPositioning'],
            buildUpPlay: ['creativity', 'crossing', 'dribbling', 'passingAccuracy'],
            defence: ['aggression', 'defensiveHeaders', 'tackling'],
            physical: ['speed', 'strength', 'workRate']
        };

        return attributeNames[categoryName].reduce((acc, attribute) => {
            acc[attribute] = createLineGenerator(attribute, scale);
            return acc;
        }, {} as Record<string, any>);
    };

    const lineGenerators = {
        finalThird: createLineGeneratorsForCategory('finalThird', finalThirdScale),
        buildUpPlay: createLineGeneratorsForCategory('buildUpPlay', buildUpPlayScale),
        defence: createLineGeneratorsForCategory('defence', defenceScale),
        physical: createLineGeneratorsForCategory('physical', physicalScale),
    };



    useEffect(() => {
        if (!TransferMarketYAxis.current || !TransferValuationSVG.current) return;

        const TransferValuationGraphSvg = d3.select(TransferValuationSVG.current);
        const TransferMarketYAxisSvg = d3.select(TransferMarketYAxis.current);
        const MatchGraphSvg = d3.select(MatchSVG.current!);
        const SeasonGraphSvg = d3.select(SeasonSVG.current!);
        const EventGraphSvg = d3.select(eventSVG.current!);
        const GoalAssistSvg = d3.select(goalAssistSVG.current!);
        const AttributionYAxisSvg = d3.select(attributionYAxis.current!);
        AttributionSvg.current = attributionSVG.current && d3.select(attributionSVG.current)!;

        // AttributionSvg.current = d3.select(attributionSVG.current!);

        const { width, height } = dimensions;

        // Set up benchmark data

        // Get transfer market value
        const tranferMarketValue = transferValueData?.transferMarketValue;
        // Calculate total graph width

        // Define X-axis scale


        // Set up default and dynamic Y-axis divisions
        const defaultYAxisDivisions = Array.from({ length: 10 }, (_, i) => ({ value: i * 10 }));
        const yAxisDivisions = transferValueData?.yAxisDivisions?.length
            ? transferValueData.yAxisDivisions
            : defaultYAxisDivisions;

        // Define Y-axis scale
        const yScale = d3.scaleLinear()
            .domain([
                d3.min(yAxisDivisions, d => d.value)!,
                d3.max(yAxisDivisions, d => d.value)!
            ])
            .range([height - margin.top - margin.bottom, 0]);

        // Process driver matches and group by season
        const driverMatches = (transferValueData?.driver || []).flatMap(driver =>
            driver.matches.map(match => ({
                seasonName: driver.seasonName,
                matchId: match.matchId
            }))
        );
        const seasonGroups = d3.group(driverMatches, d => d.seasonName);
        // Define SVG element configurations
        const svgElements: SvgElementConfig[] = [
            { ref: TransferValuationSVG, height: height, width: totalGraphWidth },
            { ref: TransferMarketYAxis, height: height, width: 200 },
            { ref: MatchSVG, height: 100, width: totalGraphWidth + margin.left + margin.right },
            { ref: SeasonSVG, height: 50, width: totalGraphWidth + margin.left + margin.right },
            { ref: eventSVG, height: 155, width: totalGraphWidth + margin.left + margin.right },
            { ref: goalAssistSVG, height: 80, width: totalGraphWidth + margin.left + margin.right },
            { ref: attributionYAxis, height: attributeGraphHeight, width: 200 + margin.left + margin.right },
            { ref: attributionSVG, height: attributeGraphHeight, width: totalGraphWidth + margin.left + margin.right }
        ];

        svgElements.forEach((element: SvgElementConfig) => {
            const svgSelection = d3.select(element.ref.current!);
            setSvgAttributes(svgSelection, element.width, element.height);
        });

        const TransferValuationGroup = createGroup(TransferValuationGraphSvg, margin);
        const TransferMarketYAxisGroup = createGroup(TransferMarketYAxisSvg, margin);
        const MatchGroup = createGroup(MatchGraphSvg, margin);
        const SeasonGroup = createGroup(SeasonGraphSvg, margin);
        const EventGroup = createGroup(EventGraphSvg, margin);
        const GoalAssistGroup = createGroup(GoalAssistSvg, margin);
        const AttributionYAxisGroup = createGroup(AttributionYAxisSvg, margin);
        AttributesGroup.current = AttributionSvg.current && createGroup(AttributionSvg.current, margin);

        const matchData = transferValueData?.driver.map(season => season.matches) ?? [];
        const SeasonData = transferValueData?.driver.map(season => season.seasonName) ?? [];
        const SeasonLogos = transferValueData?.driver.map(
            season => season.seasonTeams?.map(team => team)
        ) ?? [];
        
        const totalMatches = transferValueData?.driver.reduce((total, driver) => {
            return total + driver.matches.length;
        }, 0) ?? 0;

        const updateYAxis = drawYAxis(transferValueData?.yAxisDivisions || [],
            TransferMarketYAxisSvg, TransferMarketYAxisGroup, totalGraphWidth, yScale, height, margin);

        const rectWidth: number = totalGraphWidth / transferBenchMarkData.length;
        drawBackgroundRectangles(
            TransferValuationGroup, // SVG group
            transferValueData?.transferMarketValue! || [], // Data array
            (d, i) => i * rectWidth, // X position: calculated based on index
            () => 0, // Y position: always 0
            () => rectWidth, // Width: same for all rectangles
            () => height, // Height: full chart height
            (d, i) => colors[i % 2], // Fill color: alternate between colors
            () => "none", // Stroke color: none
            0, // Stroke width
            "background", // CSS class
            true,
            "transferMarketValue"
        );

        const yValues = transferValueData?.yAxisDivisions.map(d => d.value) ??
            Array.from({ length: 10 }, (_, i) => i * 10);
        drawHorizontalLines(TransferValuationGroup, yValues, () => (-180), () => totalGraphWidth, (d: any) => yScale(d), (d: any) => yScale(d), "horizontal-line", theme.playerDataBorder, 1);

        const line = d3.line<any>()
            .x(d => xScale(d.matchId)! + xScale.bandwidth() / 2) // Center line in the band
            .y(d => yScale(d.transferValue))
            .curve(d3.curveMonotoneX);

        // Draw the benchmark line
        // drawLinePath(TransferValuationGroup, transferBenchMarkData!, d => xScale(d.matchId)! + xScale.bandwidth() / 2, d => yScale(d.transferValue!), "#00D1A8", line!, 4);
        //Draw the market value line
        // drawLinePath(TransferValuationGroup, tranferMarketValue!, d => xScale(d.matchId)! + xScale.bandwidth() / 2, d => yScale(d.transferValue!), "#FF7800", line!, 4);
        drawLinePath(
          TransferValuationGroup,
          tranferMarketValue ?? [],  // Fallback to empty array if undefined
          d => xScale(d.matchId)! + xScale.bandwidth() / 2,
          d => yScale(d.transferValue!),
          "#FF7800",
          line!,  // Ensure line is defined
          4
      );

        //Draw Rectangles
        // Get the last points from each dataset
        const lastTransferBenchMark = transferBenchMarkData[transferBenchMarkData.length - 1];
        const lastTransferMarketValue = tranferMarketValue?.[tranferMarketValue.length - 1];
        // Calculate the last point positions for the rectangle
        const lastTransferBenchMarkX = xScale(lastTransferBenchMark.matchId)! + xScale.bandwidth() / 2;
        const lastTransferBenchMarkY = yScale(lastTransferBenchMark.transferValue);

        const lastTransferMarketValueX = lastTransferMarketValue
            ? xScale(lastTransferMarketValue.matchId)! + xScale.bandwidth() / 2
            : 0;

        const lastTransferMarketValueY = lastTransferMarketValue
            ? yScale(lastTransferMarketValue.transferValue)
            : 0;

        // Rectangle dimensions
        const rectHeight = 20;
        // Check if the lines are close enough
        const distanceThreshold = 20; // Adjust based on your scale
        const yDistance = Math.abs(lastTransferBenchMarkY - lastTransferMarketValueY);

        if (yDistance <= distanceThreshold) {
            // Draw a single rectangle for both values
            const rectY = (lastTransferBenchMarkY + lastTransferMarketValueY) / 2 - rectHeight / 2; // Center the rect vertically
            createRectangleAndText(TransferValuationGroup, lastTransferBenchMarkX, rectY, rectWidth, rectHeight, lastTransferMarketValue?.transferValueText || '', theme.secondaryButtonBackground, theme.playerColor);
        } else {
            // Draw separate rectangles for each value
            // Rectangle for TransferBenchMarkData
            // createRectangleAndText(TransferValuationGroup, lastTransferBenchMarkX, lastTransferBenchMarkY, rectWidth, rectHeight, lastTransferBenchMark.transferValueText, theme.secondaryButtonBackground, theme.playerColor);
            if (isTransferMarket && lastTransferMarketValue?.transferValueText) {
                // Rectangle for TranferMarketValue
                createRectangleAndText(TransferValuationGroup, lastTransferMarketValueX, lastTransferMarketValueY, rectWidth, rectHeight, lastTransferMarketValue?.transferValueText || '', theme.secondaryButtonBackground, theme.playerColor);
            }
        }

        drawBackgroundRectangles(
            MatchGroup, // SVG group
            transferBenchMarkData, // Data array
            (d, i) => i * rectWidth, // X position: calculated based on index
            () => 0, // Y position: always 0
            () => rectWidth, // Width: same for all rectangles
            () => height, // Height: full chart height
            (d, i) => colors[i % 2], // Fill color: alternate between colors
            () => "none", // Stroke color: none
            0, // Stroke width
            "background" // CSS class
        );
        renderMatchData(
            matchData,           // Match data array
            MatchGroup,          // D3 group to append elements to
            xScale,              // xScale function
            yScale,              // yScale function (if needed)
            theme,               // Theme object
            PositiveArrow,       // Path to PositiveArrow icon
            NegativeArrow,       // Path to NegativeArrow icon
            noImageClub          // Fallback image URL
        );


        // render Events
        drawBackgroundRectangles(
            EventGroup, // SVG group
            transferBenchMarkData, // Data array
            (d, i) => i * rectWidth, // X position: calculated based on index
            () => 0, // Y position: always 0
            () => rectWidth, // Width: same for all rectangles
            () => height, // Height: full chart height
            (d, i) => colors[i % 2], // Fill color: alternate between colors
            () => "none", // Stroke color: none
            0, // Stroke width
            "background",
            true, // CSS class
            "eventGraph"
        );
        const cumulativeX = matchData.reduce((totalWidth, seasonMatches) => {
            seasonMatches.forEach((match) => {
                // Append events for each match
                appendEventsForMatch(EventGroup, xScale, match);

                // Increment the total width for each match
                totalWidth += rectWidth;
            });
            return totalWidth;
        }, 0);

        // render Goal Assist Data
        drawBackgroundRectangles(
            GoalAssistGroup, // SVG group
            transferBenchMarkData, // Data array
            (d, i) => i * rectWidth, // X position: calculated based on index
            () => 0, // Y position: always 0
            () => rectWidth, // Width: same for all rectangles
            () => height, // Height: full chart height
            (d, i) => colors[i % 2], // Fill color: alternate between colors
            () => "none", // Stroke color: none
            0, // Stroke width
            "background", // CSS class

        );

        const xgData = matchData.flat();
        let xgValues = xgData.flatMap(d => [d.totalXgAssist, d.totalXgShot]).filter(value => value !== undefined);
        const maxValue = d3.max(xgValues);

        const yScaleXg = d3.scaleLinear()
            .domain([0, maxValue!])
            .nice()
            .range([80, 0]);

        // Draw blue bars for total xG shots
        drawBars(GoalAssistGroup, xgData, 'blue', '#B0E2F7', dataLength < 10 ? 110 : 10, rectWidth, yScaleXg);
        // Draw red bars for total xG assists
        drawBars(GoalAssistGroup, xgData, 'red', '#FFD5B0', dataLength < 10 ? 128 : 28, rectWidth, yScaleXg);


        let finalThirdEndPoints: LineEnd[] = [];
        if(selectedGraph === 'Attribute-score'){
            //render Attribute data
            if (AttributionSvg.current) {
                drawBackgroundRectangles(
                    AttributesGroup.current!, // SVG group
                    transformedData, // Data array
                    (d, i) => i * rectWidth, // X position: calculated based on index
                    () => 0, // Y position: always 0
                    () => rectWidth, // Width: same for all rectangles
                    () => attributeGraphHeight, // Height: full chart height
                    (d, i) => colors[i % 2], // Fill color: alternate between colors
                    () => "none", // Stroke color: none
                    0, // Stroke width
                    "background",// CSS class
                    true
                );

                // Scales


                const yScaleDifference = 10;
                const generateTicks = (minValue: number, maxValue: number, step: number) => {
                    return d3.range(
                        Math.floor(minValue / step) * step,
                        Math.ceil(maxValue / step) * step + 1,
                        step
                    );
                };
                const yTicks = generateTicks(minFinalScore, maxFinalScore, yScaleDifference);
                const finalThirdTicks = generateTicks(finalThirdminValue, FinalThirdmaxValue, yScaleDifference);
                const buildUpPlayTicks = generateTicks(buildUpPlayminValue, buildUpPlaymaxValue, 10);
                const defenceTicks = generateTicks(defenceminValue, defencemaxValue, 10);
                const physicalTicks = generateTicks(physicalminValue, physicalmaxValue, 10);

                const path = (svgGrp: any, data: any, color: string, lineGenerator: any, yValue?: string, endPoints?: LineEnd[], scale?: any,
                    className?: string
                ) => {
                    // Draw the path (the line)
                    if (data && data.length > 0) {
                        svgGrp.append("path")
                            .datum(data)
                            .attr("class", className)
                            .attr("fill", "none")
                            .attr("stroke", color)
                            .attr("stroke-width", 4)
                            .attr("d", lineGenerator);

                        if (yValue && endPoints && data) {
                            // Get the end point for the line (last point in the dataset)
                            const lastPointIndex = data.length - 1;
                            const endPoint: LineEnd = {
                                data: {
                                    x: xScale(data[lastPointIndex]?.id)! + xScale.bandwidth() / 2,
                                    y: scale(data[lastPointIndex][yValue]),
                                    value: data[lastPointIndex][yValue],
                                    color: color
                                },
                            };
                            // Add the end point to the array
                            endPoints.push(endPoint);
                        }

                    }

                }

                if (selectedAttribute.isFinalThird) {
                    if (allFinalScoreZero) { sethasfinalthirdNoAttributes(allFinathirdZero) }
                }
                if (selectedAttribute.isBuildUpPlay) {
                    if (allBuildUpPlayZero) { sethasbuildupNoAttributes(allBuildUpPlayZero) }
                }
                if (selectedAttribute.isDefence) {
                    if (allDefenceZero) { sethasdefenceNoAttributes(allDefenceZero) }
                }
                if (selectedAttribute.isPhysical) {
                    if (allAttributesAreZero) { sethasNoAttributes(allAttributesAreZero) }
                }



                switch (true) {
                    case selectedAttribute.isFinalThird:
                        finalThirdEndPoints = [];
                        updateAttributeYAxis.current = drawAttributeYAxis(AttributionYAxisGroup, AttributesGroup.current!, finalThirdTicks, finalThirdScale, theme,
                            totalGraphWidth, 0, 198, 170, 12);
                        if (!hasfinalthirdNoAttributes && finalThirdData.length > 0) {
                            //drawFinalThirdPaths(AttributesGroup, finalThirdData, lineGenerators)
                            !hasfinalthirdNoAttributes && path(AttributesGroup.current, finalThirdData, "#FF3864", lineGenerators.finalThird.finishingShots, 'finishingShots', finalThirdEndPoints, finalThirdScale, 'finalThirdPath finishingShots');
                            !hasfinalthirdNoAttributes && path(AttributesGroup.current, finalThirdData, "#00A1E4", lineGenerators.finalThird.finishingAerial, 'finishingAerial', finalThirdEndPoints, finalThirdScale, 'finalThirdPath finishingAerial');
                            !hasfinalthirdNoAttributes && path(AttributesGroup.current, finalThirdData, "#F2E94E", lineGenerators.finalThird.attackPositioning, 'attackPositioning', finalThirdEndPoints, finalThirdScale, 'finalThirdPath attackPositioning');
                            elements = drawMergedRectangles(AttributesGroup.current, finalThirdEndPoints, 25, finalThirdScale);
                        }
                        break;

                    case selectedAttribute.isBuildUpPlay:
                        const buildupEndPoints: LineEnd[] = [];
                        updateAttributeYAxis.current = drawAttributeYAxis(AttributionYAxisGroup, AttributesGroup.current!, buildUpPlayTicks, buildUpPlayScale, theme,
                            totalGraphWidth, 0, 198, 170, 12);
                        if (!hasbuildupNoAttributes && buildupPlayData.length > 0) {
                            //drawBuildUpPlayPaths(AttributesGroup, buildupPlayData, lineGenerators)
                            !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#FF3864", lineGenerators.buildUpPlay.creativity, 'creativity', buildupEndPoints, buildUpPlayScale, 'buildUpPath creativity');
                            !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#00A1E4", lineGenerators.buildUpPlay.crossing, 'crossing', buildupEndPoints, buildUpPlayScale, 'buildUpPath crossing');
                            !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#F2E94E", lineGenerators.buildUpPlay.dribbling, 'dribbling', buildupEndPoints, buildUpPlayScale, 'buildUpPath dribbling');
                            !hasbuildupNoAttributes && path(AttributesGroup.current, buildupPlayData, "#4AF075", lineGenerators.buildUpPlay.passingAccuracy, 'passingAccuracy', buildupEndPoints, buildUpPlayScale, 'buildUpPath passingAccuracy');
                            elements = !hasbuildupNoAttributes && drawMergedRectangles(AttributesGroup.current, buildupEndPoints, 25, buildUpPlayScale); // Call to draw merged rectangles
                        }
                        break;

                    case selectedAttribute.isDefence:
                        const defenceEndPoints: LineEnd[] = [];
                        updateAttributeYAxis.current = drawAttributeYAxis(AttributionYAxisGroup, AttributesGroup.current!, defenceTicks, defenceScale, theme,
                            totalGraphWidth, 0, 198, 170, 12);
                        if (!hasdefenceNoAttributes && defenceData.length > 0) {
                            !hasdefenceNoAttributes && path(AttributesGroup.current, defenceData, "#FF3864", lineGenerators.defence.aggression, 'aggression', defenceEndPoints, defenceScale, "defencePath aggression");
                            !hasdefenceNoAttributes && path(AttributesGroup.current, defenceData, "#00A1E4", lineGenerators.defence.defensiveHeaders, 'defensiveHeaders', defenceEndPoints, defenceScale, "defencePath defensiveHeaders");
                            !hasdefenceNoAttributes && path(AttributesGroup.current, defenceData, "#F2E94E", lineGenerators.defence.tackling, 'tackling', defenceEndPoints, defenceScale, "defencePath tackling");
                            elements = drawMergedRectangles(AttributesGroup.current, defenceEndPoints, 25, defenceScale); // Call to draw merged rectangles
                        }

                        break;

                    case selectedAttribute.isPhysical:
                        const physicalEndPoints: LineEnd[] = [];
                        updateAttributeYAxis.current = drawAttributeYAxis(AttributionYAxisGroup, AttributesGroup.current!, physicalTicks, physicalScale, theme,
                            totalGraphWidth, 0, 198, 170, 12);
                        if (!hasNoAttributes && physicalData.length > 0) {
                            !hasNoAttributes && path(AttributesGroup.current, physicalData, "#FF3864", lineGenerators.physical.speed, 'speed', physicalEndPoints, physicalScale, "physicalPath speed");
                            !hasNoAttributes && path(AttributesGroup.current, physicalData, "#00A1E4", lineGenerators.physical.strength, 'strength', physicalEndPoints, physicalScale, "physicalPath strength");
                            !hasNoAttributes && path(AttributesGroup.current, physicalData, "#F2E94E", lineGenerators.physical.workRate, 'workRate', physicalEndPoints, physicalScale, "physicalPath workRate");
                            !hasNoAttributes && drawMergedRectangles(AttributesGroup.current, physicalEndPoints, 25, physicalScale);
                            //drawPhysicalPaths(AttributesGroup, physicalData, lineGenerators)
                        }

                        break;

                    default:
                        const defaultEndPoints: LineEnd[] = [];
                        updateAttributeYAxis.current = drawAttributeYAxis(AttributionYAxisGroup, AttributesGroup.current!, yTicks, attributesYScale, theme,
                            totalGraphWidth, 0, 198, 170, 12);
                        !allFinalScoreZero && path(AttributesGroup.current!, finalThirdData, "#00D1A8", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                        !allFinalScoreZero && path(AttributesGroup.current!, buildupPlayData, "#FF7800", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                        !allFinalScoreZero && path(AttributesGroup.current!, defenceData, "#C9F0B5", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                        !allFinalScoreZero && path(AttributesGroup.current!, physicalData, "#FFC2C2", attributesLinePath, 'finalScore', defaultEndPoints, attributesYScale);
                        !allFinalScoreZero
                            && drawMergedRectangles(AttributesGroup.current, defaultEndPoints, 25, attributesYScale)

                        break;
                }
            }
        }

        // const drawBuildUpPlayPaths = (group: any, data: any, lineGenerators: any) => {
        //     // Creativity Path
        //     drawPaths(group, data, lineGenerators.buildUpPlay.creativity, "buildUpPath creativity", "#FF3864");
        //     // Crossing Path
        //     drawPaths(group, data, lineGenerators.buildUpPlay.crossing, "buildUpPath crossing", "#00A1E4");
        //     // Dribbling Path
        //     drawPaths(group, data, lineGenerators.buildUpPlay.dribbling, "buildUpPath dribbling", "#F2E94E");
        //     // Passing Accuracy Path
        //     drawPaths(group, data, lineGenerators.buildUpPlay.passingAccuracy, "buildUpPath passingAccuracy", "#4AF075");
        // }
        // const drawDefencePaths = (group: any, data: any, lineGenerators: any) => {
        //     // Aggression Path
        //     drawPaths(group, data, lineGenerators.defence.aggression, "defencePath aggression", "#FF3864");
        //     // DefensiveHeaders Path
        //     drawPaths(group, data, lineGenerators.defence.defensiveHeaders, "defencePath defensiveHeaders", "#00A1E4");
        //     // Tackling Path
        //     drawPaths(group, data, lineGenerators.defence.tackling, "defencePath tackling", "#F2E94E");

        // }
        // const drawPhysicalPaths = (group: any, data: any, lineGenerators: any) => {
        //     // Speed Path
        //     drawPaths(group, data, lineGenerators.physical.speed, "physicalPath speed", "#FF3864");
        //     // Strength Path
        //     drawPaths(group, data, lineGenerators.physical.strength, "physicalPath strength", "#00A1E4");
        //     // WorkRate Path
        //     drawPaths(group, data, lineGenerators.physical.workRate, "physicalPath workRate", "#F2E94E");
        // }
        renderSeasons(SeasonGroup, MatchGroup, TransferValuationGroup, EventGroup, GoalAssistGroup, AttributesGroup.current!, SeasonData, SeasonLogos, matchData, rectWidth, xScale, theme);
        
    }, [dimensions, transferValueData, isTransferMarket, theme, selectedGraph, selectedAttribute,isLeague ,attributeGraphHeight , finalThirdData , buildupPlayData , defenceData , physicalData , attributesDriverData]);

    const zoom: d3.ZoomBehavior<SVGSVGElement, unknown> = d3.zoom<SVGSVGElement, unknown>()
        .scaleExtent([1, 5]) // Set zoom range
        .translateExtent([
            [0, 0],
            [totalGraphWidth, attributeGraphHeight],
        ])
        .filter((event) => {
            // Allow only panning, disable zooming on mouse wheel and double-click
            return !event.ctrlKey && event.type !== "wheel" && event.type !== "dblclick";
        })
        .on("zoom", (event) => {

            if (!updateAttributeYAxis.current) return;

            const attributeYAxisContainer = document.getElementById("attributeYAxisContainer");
            const attributesCharts = document.getElementById("attributesCharts");

            const transform = event.transform;
            setCurrentScale(transform.k);
            let newHeight = attributionGraphBaseHeight * transform.k;
            setAttributeGraphHeight(newHeight);
            d3.select("#attributeYAxisSVG").attr("height", newHeight);
            attributeYAxisContainer!.style.height = `${newHeight}px`;
            d3.select("#attributeSVG").attr("height", newHeight);
            attributesCharts!.style.height = `${newHeight}px`;
            // Rescale the y-axis scale based on the zoom transform
            let currentAttributeYScale = getAttributeYScale(selectedAttribute);

            const newAttributeYScale = transform.rescaleY(currentAttributeYScale)
                .range([newHeight - bottomPadding, padding]);
            const [attributeYMin, attributeYMax] = newAttributeYScale.domain();

            const rescaledAttributeY = d3.scaleLinear()
                .domain([attributeYMin, attributeYMax]) // Adjusted domain
                .range([newHeight - bottomPadding, padding]);

            updateAttributeYAxis.current(rescaledAttributeY);
            const onzoomLevel = transform.k;

            const isZoomingIn = onzoomLevel > 1;
            // setCurrentScale(event.transform.k);

            // Hide elements when zooming in, show when zooming out
            // d3.selectAll(".merged-rect").style("opacity", isZoomingIn ? 0 : 1);
            // d3.selectAll(".merged-circle").style("opacity", isZoomingIn ? 0 : 1);
            // d3.selectAll(".merged-text").style("opacity", isZoomingIn ? 0 : 1);
            switch (true) {
                case selectedAttribute.isFinalThird:
                    pathClass = ".finalThirdPath";
                    lineGenerator = lineGenerators.finalThird;
                    break;
                case selectedAttribute.isBuildUpPlay:
                    pathClass = ".buildUpPath";
                    lineGenerator = lineGenerators.buildUpPlay;
                    break;
                case selectedAttribute.isDefence:
                    pathClass = ".defencePath";
                    lineGenerator = lineGenerators.defence;
                    break;
                case selectedAttribute.isPhysical:
                    pathClass = ".physicalPath";
                    lineGenerator = lineGenerators.physical;
                    break;
                default:
                    AttributesGroup.current!.selectAll("path")
                        .transition()
                        .duration(100)
                        //.datum(finalThirdData)
                        .attr("d", (d: any) => attributesLinePath.y((d) => rescaledAttributeY(d.finalScore))(d));
                    return;
            }
            // Other zoom operations...
            const paths = AttributesGroup.current!.selectAll(pathClass);
            paths.each(function (d: any) {
                const path = d3.select(this);
                const pathData = getPathData(path, d, lineGenerator, rescaledAttributeY);

                // Apply Y-axis scaling only (prevent X-scaling)
                path.attr("transform", `translate(0, ${transform.y}) scale(1, ${transform.k})`);
                path.style("display", "block");

                // Keep stroke width constant
                path.style("vector-effect", "non-scaling-stroke") // Prevents stroke from scaling
                    .style("stroke-width", "4px"); // Fixed width in pixels

                // Apply rescaling for the y-values based on zoom
                const rescaledYPathData = rescalePathData(pathData, rescaledAttributeY);

                // Update path with the new data
                path.transition().duration(200).attr("d", rescaledYPathData);
            });
        });


    const zoomIn = () => {
        if (attributionSVG.current && totalGraphWidth > 0 && attributeGraphHeight > 0) {
            const svgElement = d3.select(attributionSVG.current);
            svgElement.transition().call(zoom.scaleBy, 1.5); // Zoom in by a factor of 1.2
        }
    };

    // Zoom Out function
    const zoomOut = () => {
        if (attributionSVG.current && totalGraphWidth > 0 && attributeGraphHeight > 0) {
            const svgElement = d3.select(attributionSVG.current);
            svgElement.transition().call(zoom.scaleBy, 0.66); // Zoom out by a factor of 0.8
        }
    };


    const toggleLargeModal = () => {
        setLargeModalIsOpen(!isLargeModalOpen);
    };

    const handleValueGraphChange = (value: string) => {
        setSelectedGraph(value)
        setAttributeGraphHeight(414);
        setCurrentScale(1);
    };

    const handleAttributeClick = (attributeKey: keyof SelectedAttribute) => {
        setSelectedAttribute((prevState: any) => {
            // Create a new state object where all attributes are set to false
            const newState: any = {
                isFinalThird: false,
                isBuildUpPlay: false,
                isDeefence: false,
                isPhysical: false
            };

            // Set the clicked attribute to true
            newState[attributeKey] = !prevState[attributeKey];

            return newState;
        });
        if (attributeKey === 'isFinalThird') {
            if (allFinalScoreZero) { sethasfinalthirdNoAttributes(allFinathirdZero) }
        }
        if (attributeKey === 'isBuildUpPlay') {
            if (allBuildUpPlayZero) { sethasbuildupNoAttributes(allBuildUpPlayZero) }
        }
        if (attributeKey === "isDefence") {
            if (allDefenceZero) { sethasdefenceNoAttributes(allDefenceZero) }
        }
        if (attributeKey === "isPhysical") {
            if (allAttributesAreZero) { sethasNoAttributes(allAttributesAreZero) }
        }
    };

    const renderEventsInfoCard = () =>{
        return(
                <div className='events-card-container'>
                  <div className='eventscard-key-content'>
                    <LabelText className='player-search-text'>Key</LabelText>
                    <CloseIcon onClick={()=>{setEventsInfoCard(false)}} sx={{color:'#7C7D79',width:'24px',height:'24px',cursor:'pointer'}}/>
                  </div>
                  <div className='eventscard-info-container'>
                      <div className='eventscard-info'>
                        <img src={Goal}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Goal</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={Assists}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Assists</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={YellowCardSvg} width={24} height={24}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Yellow card</LabelNumber>
                      </div>
                      {/* <div className='eventscard-info'>
                        <img src={}/>
                        <LabelText>-</LabelText>
                        <LabelText>2nd yellow card</LabelText>
                      </div> */}
                      <div className='eventscard-info'>
                        <img src={RedCardSvg} width={24} height={24}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Straight red card</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={Opportunity} width={24} height={24}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Player of the match</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={suspIcon}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Suspended</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={injIcon}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Injured</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={dnpIcon}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Did not play</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={subOnIcon}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Subbed ON (MIN)</LabelNumber>
                      </div>
                      <div className='eventscard-info'>
                        <img src={subOffIcon}/>
                        <LabelText>-</LabelText>
                        <LabelNumber className='percentile-text'>Subbed OFF (MIN)</LabelNumber>
                      </div>
                  </div>
              
                </div>
        )
    }

    const renderSeasonValuationInfoCard = () =>{
        return(
        <div className='valation-info-container'>
            <div className='valuation-info-header'>
                <LabelText className='player-search-text'>{seasonValuationInfo?.matchDate} </LabelText>
                <CloseIcon onClick={()=>{setSeasonValuationInfo(null)}} sx={{color:'#7C7D79',width:'24px',height:'24px',cursor:'pointer'}}/>
            </div>
            <div className='valuation-info-values-container'>
                {/* <div className='valuation-info-values'>
                    <div className='square-box'></div>
                    <LabelNumber className='percentile-text'>MF market valuation</LabelNumber>
                    <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>£</LabelNumber>
                </div> */}
                <div className='valuation-info-values'>
                    <div className='square-box transfer-market'></div>
                    <LabelNumber className='percentile-text'>TransferMarkt valuation</LabelNumber>
                    <LabelNumber className='player-card-value'style={{flex:'1 0 0'}}>£{seasonValuationInfo?.transferMarketValue}</LabelNumber>
                </div>
            </div>
        </div>
        )
                    
    }

    const renderAttributesInfoCard = () =>{
        return(
            <div className='attributes-info-main'>
                {/* <div style={{borderBottom : '1px solid #DADADA'}}></div> */}
            <div className='attributes-info-header'>
                <LabelText className='player-search-text'>{seasonAtrributesInfo?.matchDate} </LabelText>
                <CloseIcon onClick={()=>{setSeasonAttributesInfo(null)}} sx={{color:'#7C7D79',width:'24px',height:'24px',cursor:'pointer'}}/>

            </div>
            <div className={`attributes-info-container ${!selectedInfoAttribute?.isFinalThird ? 'with-border' : ''}`}>
                    <div className='square-box'></div>
                    <LabelText className='player-given-name'>Final third</LabelText>
                    <LabelNumber  style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.finalThird.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isFinalThird && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({...prev,isFinalThird: false,}))}/>)}
                    {!selectedInfoAttribute.isFinalThird && (
                        <ExpandMoreIcon className='expand-icon' onClick={() =>setSelectedInfoAttribute((prev) => ({...prev,isFinalThird: true,}))}/>
                    )}

                    
            </div>
            {selectedInfoAttribute.isFinalThird && (
                <div className={`valuation-info-values-container ${selectedInfoAttribute?.isFinalThird ? 'with-border' : ''}`} >
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>Finishing - Shots</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.finalThird.finishingShots}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>Finishing - Aerial</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.finalThird.finishingAerial}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>Attack positioning</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.finalThird.attackPositioning}</LabelNumber>
                    </div>
                </div>
            )}
            <div className={`attributes-info-container ${!selectedInfoAttribute?.isBuildUpPlay ? 'with-border' : ''}`}>

                    <div className='square-box transfer-market'></div>
                    <LabelText className='player-given-name'>Build up play</LabelText>
                    <LabelNumber style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.buildUpPlay.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isBuildUpPlay && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({...prev,isBuildUpPlay: false,}))}/>)}
                    {!selectedInfoAttribute.isBuildUpPlay && (
                        <ExpandMoreIcon className='expand-icon' onClick={() =>setSelectedInfoAttribute((prev) => ({...prev,isBuildUpPlay: true,}))}/>
                    )}
                
            </div>
            {selectedInfoAttribute.isBuildUpPlay && (
                <div className={`valuation-info-values-container ${selectedInfoAttribute?.isBuildUpPlay ? 'with-border' : ''}`} >
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>creativity</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.buildUpPlay.creativity}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>crossing</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.buildUpPlay.crossing}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>dribbling</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.buildUpPlay.dribbling}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>passing accuracy</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.buildUpPlay.passingAccuracy}</LabelNumber>
                    </div>
                </div>
            )}
            <div className={`attributes-info-container ${!selectedInfoAttribute?.isDefence ? 'with-border' : ''}`}>

                    <div className='square-box defence'></div>
                    <LabelText className='player-given-name'>Defence</LabelText>
                    <LabelNumber style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.defence.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isDefence && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({...prev,isDefence: false,}))}/>)}
                    {!selectedInfoAttribute.isDefence && (
                        <ExpandMoreIcon className='expand-icon' onClick={() =>setSelectedInfoAttribute((prev) => ({...prev,isDefence: true,}))}/>
                    )}

            </div>
            {selectedInfoAttribute.isDefence && (
                <div className={`valuation-info-values-container ${selectedInfoAttribute?.isDefence ? 'with-border' : ''}`} >
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>ball recovery</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.defence.aggression}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>defensive Headers</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.defence.defensiveHeaders}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>tackling</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.defence.tackling}</LabelNumber>
                    </div>
                </div>
            )}
            <div className='attributes-info-container'>  
                    <div className='square-box physical'></div>
                    <LabelText className='player-given-name'>Physical</LabelText>
                    <LabelNumber style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.physical.finalScore}</LabelNumber>
                    {selectedInfoAttribute.isPhysical && (<ExpandLessIcon className='expand-icon' onClick={() => setSelectedInfoAttribute((prev) => ({...prev,isPhysical: false,}))}/>)}
                    {!selectedInfoAttribute.isPhysical && (
                        <ExpandMoreIcon className='expand-icon' onClick={() =>setSelectedInfoAttribute((prev) => ({...prev,isPhysical: true,}))}/>
                    )}

                
            </div>
             {selectedInfoAttribute.isPhysical && (
                <div className='valuation-info-values-container'>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>speed</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.physical.speed}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>strength</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.physical.strength}</LabelNumber>
                    </div>
                    <div className='valuation-info-values'>
                                <LabelNumber className='percentile-text'>work rate</LabelNumber>
                                <LabelNumber className='player-card-value' style={{flex:'1 0 0'}}>{seasonAtrributesInfo?.physical.workRate}</LabelNumber>
                    </div>
                </div>
            )}
        </div>
        )
    }

    const handlePositionToggle = () => {
        // startLoading();
        setIsLeague(prevState => !prevState);
    };


    const [scrollDirection, setScrollDirection] = useState<'ltr' | 'rtl'>('ltr');

    useEffect(() => {
      
        if (totalGraphWidth > containerWidth) {
          setScrollDirection('rtl');
        } else {
          setScrollDirection('ltr');
        }
      }, [totalGraphWidth, isFullView]);


    return (
        <>
            <ModalProvider>
                <LargeModal toggleLargeModal={toggleLargeModal} isOpen={isLargeModalOpen} data={modalData} />
            </ModalProvider>
           
            <div className={`value-graph-chart ${isFullView && 'fullview-chart'} `}>

                <YAxisContainer>
                    <SvgStyled ref={TransferMarketYAxis} style={{borderBottom :'2px solid #DADADA'}}/>
                    <BottomSideBar className='bottom-sidebar'>
                        <BottomLeftContainer className='drivers'>
                            {isFullView && (
                                <div className='drivers-matches'>
                                    <LabelNumber className='club-info-value'>Drivers</LabelNumber>
                                    <CustomDropdown
                                        options={Options}
                                        deafaultSelected='Football'
                                        onChange={handleValueGraphChange}
                                        className='value-graph-dropdown'
                                        isDisplaySearchInput={false}
                                        Id={playerId!}
                                    />
                                </div>
                            )}
                        </BottomLeftContainer>
                        {isFullView && selectedGraph === 'Football' && (
                            <>
                                <BottomLeftContainer className='events'>
                                    <div className='drivers-matches'>
                                        <LabelText className='overall-text'>Match Events</LabelText>
                                    </div>
                                </BottomLeftContainer>
                                {/* <BottomLeftContainer className='contribution'>
                                     <LabelText>Contribution</LabelText>
                                        </BottomLeftContainer> */}
                                <BottomLeftContainer className='goals-assists-chart'>
                                    <div className='goal-assists-info'>
                                        <div className='goal-assists-info-text'>
                                            <span className="circle x-goal"></span>
                                            <LabelText className='overall-text'>X Goals</LabelText>
                                        </div>
                                        <div className='goal-assists-info-text'>
                                            <span className="circle x-assists"></span>
                                            <LabelText className='overall-text'>X assists</LabelText>
                                        </div>
                                    </div>
                                </BottomLeftContainer>
                            </>
                        )}
                         {isFullView && selectedGraph === 'Attribute-score' && (
                            <>
                                <div id="attributeYAxisContainer"><svg ref={attributionYAxis} id="attributeYAxisSVG" /></div>
                                <div className="zoom-buttons-container">
                                    <SecondaryButton iconType='zoomout' onClick={zoomOut} disabled={currentScale <= 1} />
                                    <SecondaryButton iconType='zoomin' onClick={zoomIn} disabled={currentScale >= 4} />
                                </div>
                            </>
                        )}
                        <BottomLeftContainer className='season'></BottomLeftContainer>
                    </BottomSideBar>
                </YAxisContainer>

                <div  ref={containerRef} className={isFullView ? 'scrollbar-container-fullview' : 'scrollbar-container'} style={{direction : scrollDirection}}>
                    {isLoading && <ModuleSpinner isLargeLoading={isFullView} />}
                    <div className='testing' style={{ background:`url(${noDataBackground})`}}>
                        <div className='value-graph-chart-top-svg'>
                            <SvgStyled ref={TransferValuationSVG} style={{borderRight :'2px solid #DADADA'}}/>
                            {seasonValuationInfo && isFullView  && renderSeasonValuationInfoCard()}
                        </div>
                        <div className='value-graph-chart-bottom-svg'>
                            {/* {isFullView && transferBenchMarkData && (<LabelNumber className='attack-defense-data' style={{transform: 'rotate(-90deg)',position:'absolute',marginRight:totalGraphWidth-80,bottom:isFullView ?'264px' : ''}}>Player data start date</LabelNumber>)} */}

                            <div className='drivers-svg' >
                                
                                <SvgStyled ref={MatchSVG} style={{borderRight :'2px solid #DADADA',direction:'rtl'}}/>

                                {/* <div><LabelNumber className='attack-defense-data' style={{transform: 'rotate(-90deg)'}}>Player data start date</LabelNumber></div> */}
                            </div>

                            {isFullView && selectedGraph === 'Football' && (
                                <>
                                    <div className='events-svg' ><SvgStyled ref={eventSVG} style={{borderRight :'2px solid #DADADA',direction:'rtl'}}/></div>
                                    {/* <div className='contribution-svg'><MatchSvg ref={contributionSVG} /></div> */}
                                    <div className='goals-assists-chart'><SvgStyled ref={goalAssistSVG} style={{borderRight :'2px solid #DADADA'}}/></div>
                                    {/* eventsCard : */}
                                    {eventsInfoCard && (
                                    renderEventsInfoCard()
                                    )}
                                </>
                            )}
                            {isFullView && selectedGraph === 'Attribute-score' && (
                                <>
                                    <div className='attributes-charts' id="attributesCharts" >
                                        {renderSelectedAttributeDetails(selectedAttribute)}
                                        <Exapanders className='attributes-expander'>
                                        <Switch 
                                            id="position" 
                                            toggled={isLeague} 
                                            onChange={handlePositionToggle} 
                                            source='Filter' 
                                            title="League"
                                            isByComparison={false}
                                            type='valueGraph'
                                        />
                                        <div style={{height:'24px',border : '1px solid #DADADA'}}></div>
                                            {attributes.map(({ key, label, color }) => (
                                                <div className='attributes' key={key}>
                                                    <span className='attributes-marker' style={{ backgroundColor: color }}></span>
                                                    <LabelNumber className='position-text attribute-text'>{label}</LabelNumber>
                                                    <SecondaryButton
                                                        iconType='expander'
                                                        onClick={() => handleAttributeClick(key as keyof SelectedAttribute)}
                                                        isSelected={selectedAttribute[key as keyof SelectedAttribute]}
                                                    />
                                                </div>
                                            ))}
                                        </Exapanders>
                                        {(
                                            (hasNoAttributes && selectedAttribute.isPhysical) ||
                                            (hasbuildupNoAttributes && selectedAttribute.isBuildUpPlay) ||
                                            (hasfinalthirdNoAttributes && selectedAttribute.isFinalThird) ||
                                            (hasdefenceNoAttributes && selectedAttribute.isDefence)
                                        ) && (
                                                <>
                                                    <div className='no-attributes'></div>
                                                    <div className='no-attribute'>
                                                        <LabelText>Player’s<br /> score below<br />  threshold<br />
                                                            <HelpOutlineIcon onClick={toggleLargeModal} className="clickable" />
                                                        </LabelText>
                                                    </div>
                                                </>
                                            )
                                        }
                                         <SvgStyled ref={attributionSVG} id="attributeSVG" style={{borderLeft :'2px solid #DADADA'}}/>
                                        {seasonAtrributesInfo && isFullView && renderAttributesInfoCard()}
                                    </div>
                                </>
                            )}

                            <div className='season' ref={chartRef} style={{ position: 'relative' }}>
                                <SvgStyled ref={SeasonSVG}  style={{background:'white',borderRight :'2px solid #DADADA',direction:'rtl'}}/>
                                {/* {currentSeason && (
                                    <div className="sticky-season-label"
                                        style={{ position: 'absolute', top: '10px', left: '10px', background: '#fff', padding: '5px', border: '1px solid #000', zIndex: 1 }}>
                                        {currentSeason}
                                    </div>
                                )} */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* {displayCustomNotification && (
        <PWNotification
          message={customNotificationContent}
          setIsNotification={() => setDisplayCustomNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification zoom-notification"
        />
      )} */}
        </>
    )
}

export default ValueGraphChart;
